import { render } from "./ContentBuilding.vue?vue&type=template&id=5efb11da"
import script from "./ContentBuilding.vue?vue&type=script&lang=js"
export * from "./ContentBuilding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/help/ContentBuilding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5efb11da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5efb11da', __exports__)) {
    api.reload('5efb11da', __exports__)
  }
  
  module.hot.accept("./ContentBuilding.vue?vue&type=template&id=5efb11da", () => {
    api.rerender('5efb11da', render)
  })

}


export default __exports__